import { render, staticRenderFns } from "./AdminAlerts.vue?vue&type=template&id=1d90ac76"
import script from "./AdminAlerts.vue?vue&type=script&lang=js"
export * from "./AdminAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports